import TaxonomyAdminScreen from "../taxonomy/taxonomy-admin-screen.tsx";

export default function LanguagesScreen() {
  return <TaxonomyAdminScreen type="languages" title="زبان‌ها" />;
}
